import { NgModule } from '@angular/core';
import { ParametrosStateModule } from '@vip/state/parametros';
import { AuthService } from './auth.service';

@NgModule({
  imports: [ParametrosStateModule],
  providers: [AuthService],
})
export class AuthModule {}
